<template>
  <teleport to="head">
    <title>{{ HEAD_TITLE }} | Enroll</title>
  </teleport>
  <UnauthNav />
  <div class="lcu-enroll-page">
    <SecondaryNav />
    <div
      class="lcu-enroll-box"
      :class="{
        'lcu-box-large': enrollStep === 'fee'
      }">
      <div>
        <section class="section">
          <header class="lcu-section-header lcu-center-text">
            Inscribirse en Legacy Christian University
          </header>
        </section>
        <div v-if="!testMode" class="coming-soon">
          Próximamente: Inscripciones en línea
        </div>
        <div v-if="testMode">
        <section class="section">
          <bullet-legend :amount="4" :current="getCurrentStep" />
        </section>
        <div
          class="row row-large"
          :class="{ 'lcu-enroll-formError' : signupError }">
          <div class="row-large" v-if="enrollStep === 'profile'">
            <section class="section">
              <header class="lcu-section-subHeader lcu-center-text">Información del Perfil</header>
            </section>
            <!-- First / Last name wrapper -->
            <div class="row row-large">
              <div class="row row-small">
                <div class="col-grid-2">
                  <div class="lcu-mobile-bump">
                    <div class="row row-small">
                      <form-field :id="'first-name'" :label="''">
                        <label
                          for="first-name"
                          :class="{
                            'lcu-form-risen': validations.firstName.value !== '',
                          }"
                          class="lcu-form-riser">
                          Nombre
                          <span class="lcu-enroll-required" />
                        </label>
                        <input
                          type="text"
                          id="first-name"
                          @input="validate(['firstName'])"
                          autocomplete="on"
                          v-model="validations.firstName.value"
                          :class="{
                            'lcu-enroll-inputError': validations.firstName.errors.length > 0
                          }"
                          class="lcu-enroll-inputText" />
                      </form-field>
                    </div>
                    <div class="row row-small" v-if="validations.firstName.errors.length > 0">
                      <span class="lcu-enroll-errorMsg">
                        {{ validations.firstName.errors.join(' ') }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div class="row row-small">
                      <form-field :id="'last-name'" :label="''">
                        <label
                          for="last-name"
                          :class="{
                            'lcu-form-risen': validations.lastName.value !== '',
                          }"
                          class="lcu-form-riser">
                          Apellido
                          <span class="lcu-enroll-required" />
                        </label>
                        <input
                          type="text"
                          id="last-name"
                          @input="validate(['lastName'])"
                          autocomplete="on"
                          v-model="validations.lastName.value"
                          :class="{
                            'lcu-enroll-inputError': validations.lastName.errors.length > 0
                          }"
                          class="lcu-enroll-inputText" />
                      </form-field>
                    </div>
                    <div class="row row-small" v-if="validations.lastName.errors.length > 0">
                      <span class="lcu-enroll-errorMsg">
                        {{ validations.lastName.errors.join(' ') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Email wrapper -->
            <div class="row row-large">
              <div class="row row-small">
                <form-field :id="'email'" :label="''">
                  <label
                    for="email"
                    :class="{
                      'lcu-form-risen': validations.email.value !== '',
                    }"
                    class="lcu-form-riser">
                    Correo Electrónico
                    <span class="lcu-enroll-required" />
                  </label>
                  <input
                    type="email"
                    id="email"
                    autocomplete="on"
                    v-model="validations.email.value"
                    @input="validate(['email'])"
                    :class="{
                      'lcu-enroll-inputError': validations.email.errors.length > 0
                    }"
                    class="lcu-enroll-inputText" />
                </form-field>
              </div>
              <div class="row row-small" v-if="validations.email.errors.length > 0">
                <span class="lcu-enroll-errorMsg">
                  {{ validations.email.errors.join(' ') }}
                </span>
              </div>
            </div>
            <!-- Phone wrapper -->
            <div class="row row-large">
              <div class="row row-small">
                <form-field :id="'phone'" :label="''">
                  <label
                    for="phone"
                    :class="{
                      'lcu-form-risen': validations.phone.value !== '',
                    }"
                    class="lcu-form-riser">
                    Teléfono
                    <span class="lcu-enroll-required" />
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    autocomplete="on"
                    v-model="validations.phone.value"
                    @input="validate(['phone'])"
                    :class="{
                      'lcu-enroll-inputError': validations.phone.errors.length > 0
                    }"
                    class="lcu-enroll-inputText" />
                </form-field>
              </div>
              <div class="row row-small" v-if="validations.phone.errors.length > 0">
                <span class="lcu-enroll-errorMsg">
                  {{ validations.phone.errors.join(' ') }}
                </span>
              </div>
            </div>
            <!-- Country wrapper -->
            <div
              class="row row-large lcu-enroll-selectWrap"
              :class="{ 'lcu-active-selectRequired': pais === 'pais' }">
              <div class="row row-small">
                <form-field
                  :id="'country'" :label="pais === 'pais' ? '' : 'Pais'" required>
                  <select
                    id="country"
                    name="country"
                    v-model="pais"
                    :class="{ 'lcu-enroll-inputError': countryError }"
                    @change="validateSelects({ error: 'countryError', value: 'pais' })"
                    class="lcu-enroll-select">
                    <option
                      v-for="option in ['pais', ...countries]"
                      :disabled="option === 'pais'"
                      :value="option"
                      :key="option">
                      {{ _startCase(option) }}
                    </option>
                  </select>
                  <span class="lcu-enroll-selectIcon"></span>
                </form-field>
              </div>
              <div class="row row-small" v-if="countryError">
                <span class="lcu-enroll-errorMsg">
                  {{ formValidationMessages.required }}
                </span>
              </div>
            </div>
            <!-- Gender wrapper -->
            <div
              class="row row-large lcu-enroll-selectWrap"
              :class="{
                'lcu-active-selectRequired': género === 'género'
                }">
              <div class="row row-small">
                <form-field
                  :id="'gender'"
                  :label="género === 'género' ? '' : 'Género'" required>
                  <select
                    id="gender"
                    name="gender"
                    v-model="género"
                    :class="{ 'lcu-enroll-inputError': genderError }"
                    @change="validateSelects({ error: 'genderError', value: 'género' })"
                    class="lcu-enroll-select">
                    <option
                      v-for="g in ['género', 'masculino', 'femenino']"
                      :disabled="g === 'género'"
                      :value="g"
                      :key="g">
                      {{ g !== 'género' ? _startCase(g) : 'Género' }}
                    </option>
                  </select>
                  <span class="lcu-enroll-selectIcon"></span>
                </form-field>
              </div>
              <div class="row row-small" v-if="genderError">
                <span class="lcu-enroll-errorMsg">
                  {{ formValidationMessages.required }}
                </span>
              </div>
            </div>
            <!-- Birthday wrapper -->
            <div class="row row-large">
              <div class="row row-small">
                <form-field :id="'birthday'" :label="''">
                  <label
                    for="birthday"
                    :class="{
                      'lcu-form-risen': validations.birthday.value !== '',
                    }"
                    class="lcu-form-riser">
                    Fecha de Nacimiento (MM / DD / YYYY)
                    <span class="lcu-enroll-required" />
                  </label>
                  <input
                    type="text"
                    id="birthday"
                    v-model="validations.birthday.value"
                    v-maska="'## / ## / ####'"
                    autocomplete="on"
                    @input="validate(['birthday'])"
                    :class="{
                      'lcu-enroll-inputError': validations.birthday.errors.length > 0
                    }"
                    class="lcu-enroll-inputText" />
                </form-field>
              </div>
              <div class="row row-small" v-if="validations.birthday.errors.length > 0">
                <span class="lcu-enroll-errorMsg">
                  {{ validations.birthday.errors.join(' ') }}
                </span>
              </div>
            </div>
            <div>
              <div class="col-grid-2">
                <div />
                <button-cta
                  :text="'SIGUIENTE'"
                  @on-click="validateProfileStep" />
              </div>
            </div>
          </div>
          <div class="row-large" v-if="enrollStep === 'security'">
          <!-- Passwords wrapper -->
            <section class="section">
              <header class="lcu-section-subHeader lcu-center-text">Seguridad</header>
            </section>
            <div class="row row-large">
              <div class="row row-small">
                <form-field :id="'new-password'" :label="''">
                  <label
                    for="new-password"
                    :class="{
                      'lcu-form-risen': validations.newPassword.value !== '',
                    }"
                    class="lcu-form-riser">
                    Nueva Contraseña
                    <span class="lcu-enroll-required" />
                  </label>
                  <input
                    :type="showNewPass ? 'text' : 'password'"
                    id="new-password"
                    @input="validate(['newPassword']); checkConfirm(); showHint();"
                    v-model="validations.newPassword.value"
                    :class="{
                      'lcu-enroll-inputError': newPassError || showCriteriaError,
                    }"
                    class="lcu-enroll-inputText" />
                  <tooltip
                    :text="(showNewPass ? 'Hide' : 'Show') + ' Password'"
                    :tag="'button'"
                    name="show-new-password"
                    :on-click="() => { showNewPass = !showNewPass; }"
                    :classes="['lcu-icon-eyeSlash', {
                      'lcu-icon-eye': showNewPass
                    }]">
                  </tooltip>
                </form-field>
              </div>
              <div class="row row-small" v-if="newPassError || showCriteriaError">
                <span class="lcu-enroll-errorMsg">
                  {{ validations.newPassword.errors.join(' ') }}
                  <span v-if="confirmError"> {{ confirmError }} </span>
                  <span v-if="showCriteriaError"> {{ formValidationMessages.passwordCriteria }}</span>
                </span>
              </div>
              <div class="row row-small" v-if="showHintGroup">
                <div class="lcu-passHint-group">
                  <span
                    class="lcu-hintPass"
                    :class="{ 'lcu-hintPass-good': hint.lc }">
                    {{ passwordHintMessages.lc }}
                  </span><br/>
                  <span
                    class="lcu-hintPass"
                    :class="{ 'lcu-hintPass-good': hint.uc }">
                    {{ passwordHintMessages.uc }}
                  </span><br/>
                  <span
                    class="lcu-hintPass"
                    :class="{ 'lcu-hintPass-good': hint.num }">
                    {{ passwordHintMessages.num }}
                  </span><br/>
                  <span
                    class="lcu-hintPass"
                    :class="{ 'lcu-hintPass-good': hint.sym }">
                    {{ passwordHintMessages.sym }}
                  </span><br/>
                  <span
                    class="lcu-hintPass"
                    :class="{ 'lcu-hintPass-good': hint.len }">
                    {{ passwordHintMessages.len }}
                  </span><br/>
                </div>
              </div>
            </div>
            <div class="row row-large">
              <div class="row row-small">
                <form-field :id="'confirm-password-confirm'" :label="''">
                  <label
                    for="confirm-password-confirm"
                    :class="{
                      'lcu-form-risen': validations.confirmPass.value !== '',
                    }"
                    class="lcu-form-riser">
                    Confirmar Contraseña
                    <span class="lcu-enroll-required" />
                  </label>
                  <input
                    :type="showConfirmPass ? 'text' : 'password'"
                    id="confirm-password-confirm"
                    v-model="validations.confirmPass.value"
                    :class="{
                      'lcu-enroll-inputError': confirmPassError
                    }"
                    @input="validate(['confirmPass']); checkConfirm();"
                    class="lcu-enroll-inputText" />
                  <tooltip
                    :text="(showConfirmPass ? 'Hide' : 'Show') + ' Password'"
                    :tag="'button'"
                    name="show-new-password"
                    :on-click="() => { showConfirmPass = !showConfirmPass; }"
                    :classes="['lcu-icon-eyeSlash', {
                      'lcu-icon-eye': showConfirmPass
                    }]">
                  </tooltip>
                </form-field>
              </div>
              <div class="row row-small" v-if="confirmPassError">
                <span class="lcu-enroll-errorMsg">
                  {{ validations.confirmPass.errors.join(' ') }}
                  <span v-if="confirmError"> {{ confirmError }}</span>
                </span>
              </div>
            </div>
            <div class="col-grid-2">
                <button-cta
                  :text="'ATRÁS'"
                  :classes="['lcu-back-icon']"
                  :disabled="loaders.security"
                  border
                  @on-click="enrollStep = 'profile'" />
                <vue-recaptcha
                  ref="vueRecaptcha"
                  v-show="false"
                  :sitekey="reCaptchaKey"
                  size="invisible"
                  @verify="onSignup"
                  @fail="recaptchaFailed"
                  @error="recaptchaError"
                  @expire="resetCaptcha">
                </vue-recaptcha>
                <button-cta
                  :text="'SIGUIENTE'"
                  :loading="loaders.security"
                  @on-click="validateSecurityStep" />
            </div>
          </div>
          <div class="row-large" v-if="enrollStep === 'confirm-account'">
            <section class="section">
              <header class="lcu-section-subHeader lcu-center-text">Confirmar Cuenta</header>
            </section>
            <div class="row row-small">
              <form-field :id="'code'" :label="''">
                <label
                  for="code"
                  :class="{
                    'lcu-form-risen': validations.code.value !== '',
                  }"
                  class="lcu-form-riser">
                  Ingresa el código temporal enviado a tu correo electrónico
                  <span class="lcu-enroll-required" />
                </label>
                <input
                  type="code"
                  id="code"
                  v-model="validations.code.value"
                  @input="validate(['code'])"
                  :class="{
                    'lcu-enroll-inputError': validations.code.errors.length > 0
                  }"
                  class="lcu-enroll-inputText" />
              </form-field>
            </div>
            <div class="row row-small" v-if="validations.code.errors.length > 0">
              <span class="lcu-enroll-errorMsg">
                {{ validations.code.errors.join(' ') }}
              </span>
            </div>
            <div class="row row-large">
              <p class="lcu-login-smallP">
                <spin-loader
                  v-if="resendLoading & !resendSuccess"
                  :tiny="true"
                  :color="'white'" />
                <span v-if="!resendLoading && resendSuccess">
                  Se ha reenviado el código.!
                </span>
                <a
                  v-if="!resendLoading && !resendSuccess"
                  href="#"
                  @click.prevent="resendCode"
                  class="lcu-login-link">
                  Reenviar Código
                </a>
              </p>
            </div>
            <div class="col-grid-2">
              <div />
              <button-cta
                :text="'CONFIRMAR Y CONTINUAR'"
                :loading="loaders.confirmCode"
                @on-click="validateConfirmCode" />
            </div>
          </div>
          <div class="row-large" v-if="enrollStep === 'fee'">
              <section class="section">
                <header class="lcu-section-subHeader lcu-center-text">Cuota de Inscripción</header>
              </section>
              <div v-if="!showCompletedEnrollment">
                <div class="row row-large">
                  <div class="col-grid-2">
                    <div>
                      <div class="row row-large">
                        <div class="row row-small">
                          <form-field :id="'name'" :label="'Nombre en Tarjeta'" required>
                            <input
                              type="text"
                              id="name"
                              @input="validate(['name'])"
                              v-model="validations.name.value"
                              :class="{
                                'lcu-enroll-inputError': validations.name.errors.length > 0
                              }"
                              class="lcu-enroll-inputText" />
                          </form-field>
                        </div>
                        <div class="row row-small" v-if="validations.name.errors.length > 0">
                          <span class="lcu-enroll-errorMsg">
                            {{ validations.name.errors.join(' ') }}
                          </span>
                        </div>
                      </div>
                      <div class="row row-large">
                        <div class="row row-small">
                          <form-field :id="'card-number'" :label="'Número de Tarjeta'" required>
                            <input
                              type="text"
                              id="card-number"
                              @input="validate(['cardNum'])"
                              autocomplete="cc-number"
                              placeholder="0000 0000 0000 0000"
                              v-maska="'#### #### #### ####'"
                              v-model="validations.cardNum.value"
                              :class="{
                                'lcu-enroll-inputError': validations.cardNum.errors.length > 0
                              }"
                              class="lcu-enroll-inputText" />
                          </form-field>
                        </div>
                        <div class="row row-small" v-if="validations.cardNum.errors.length > 0">
                          <span class="lcu-enroll-errorMsg">
                            {{ validations.cardNum.errors.join(' ') }}
                          </span>
                        </div>
                      </div>
                      <div class="row row-large">
                        <div class="col-grid-2">
                          <div class="lcu-mobile-bump">
                            <div class="row row-small">
                              <form-field :id="'exp-date'" :label="'Fecha de Expiración'" required>
                                <input
                                  type="text"
                                  id="exp-date"
                                  @input="validate(['expDate'])"
                                  placeholder="00 / 00"
                                  v-maska="'## / ##'"
                                  v-model="validations.expDate.value"
                                  :class="{
                                    'lcu-enroll-inputError': validations.expDate.errors.length > 0
                                  }"
                                  class="lcu-enroll-inputText" />
                              </form-field>
                            </div>
                            <div class="row row-small" v-if="validations.expDate.errors.length > 0">
                              <span class="lcu-enroll-errorMsg">
                                {{ validations.expDate.errors.join(' ') }}
                              </span>
                            </div>
                          </div>
                          <div>
                            <div class="row row-small">
                              <form-field :id="'cvv'" :label="'CVV'" required>
                                <input
                                  type="text"
                                  id="cvv"
                                  @input="validate(['cvv'])"
                                  placeholder="000"
                                  v-maska="'###'"
                                  v-model="validations.cvv.value"
                                  :class="{
                                    'lcu-enroll-inputError': validations.cvv.errors.length > 0
                                  }"
                                  class="lcu-enroll-inputText" />
                              </form-field>
                            </div>
                            <div class="row row-small" v-if="validations.cvv.errors.length > 0">
                              <span class="lcu-enroll-errorMsg">
                                {{ validations.cvv.errors.join(' ') }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row row-large">
                        <form-field
                          :id="'save-payment'"
                          :sideLabel="true"
                          :label="'Guardar Método de Pago'">
                          <input
                            type="checkbox"
                            name="save-payment"
                            id="save-payment"
                            v-model="savePaymentMethod"
                            class="lcu-form-checkbox" />
                        </form-field>
                      </div>
                    </div>
                    <div class="lcu-summary-box">
                      <div class="row">
                        <div class="lcu-summary-item">
                          <img
                            src="/assets/default-course-logo.png"
                            class="lcu-summary-itemImage" />
                          <div>
                            <p>Cuota única de inscripción</p>
                            <strong class="lcu-fee-price">
                              {{ pricing.subtotal }} ({{ pricing.currency }})
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <hr class="line-break"/>
                      </div>
                      <div class="row">
                        <div class="lcu-discount-input">
                          <form-field :id="'discount'" :label="''">
                            <input
                              type="text"
                              id="discount"
                              v-model="discount"
                              @input="validateDiscount"
                              :readonly="discountApplied"
                              placeholder="Código de descuento"
                              :class="{
                                'lcu-register-inputError': discountError,
                                'lcu-disabled-input': discountApplied
                              }"
                              class="lcu-form-inputText lcu-input-discount" />
                          </form-field>
                          <button-cta
                            :text="!discountApplied ? 'Aplicar' : 'Limpiar'"
                            :type="'primary-light'"
                            :loading="discountLoader"
                            :disabled="discountLoader"
                            @on-click="!discountApplied ? onApplyDiscount() : clearDiscount()" />
                        </div>
                        <div class="row row-small" v-if="discountError">
                          <span class="lcu-discount-errorMsg">
                            {{ discountError }}
                          </span>
                        </div>
                      </div>
                      <div class="row">
                        <hr class="line-break"/>
                      </div>
                      <div class="row">
                        <div class="lcu-summary-totals">
                          <span>Subtotal: </span>
                          <span>{{ pricing.subtotal }}</span>
                          <span
                            class="lcu-summary-savings"
                            v-if="savings">Savings:</span>
                          <span
                            class="lcu-summary-savings"
                            v-if="savings">- {{ savings }}</span>
                          <span>Impuestos: </span>
                          <span>{{ pricing.taxes }}</span>
                          <span class="lcu-summary-total">Total: </span>
                          <span class="lcu-summary-total">{{ pricing.total }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-grid-2">
                  <div />
                  <div>
                    <div class="row">
                        <form-field
                          :id="'agree-terms'"
                          :sideLabel="true"
                          :links="[{
                            text: 'Ver términos.',
                            href: '/terminos-de-uso',
                            target: '_blank',
                            rel: 'noopener noreferrer',
                          }]"
                          :label="TERMS_LABEL">
                          <input
                            type="checkbox"
                            name="agree-terms"
                            id="agree-terms"
                            v-model="agreeTerms"
                            class="lcu-form-checkbox" />
                        </form-field>
                    </div>
                    <button-cta
                      :text="'PAGAR E INSCRIBIRSE'"
                      :type="'secondary'"
                      :classes="['full-width-btn']"
                      :disabled="!agreeTerms"
                      :loading="loaders.confirmAndPay"
                      @on-click="confirmAndPay" />
                  </div>
                </div>
              </div>
              <div v-if="showCompletedEnrollment">
                <div class="row row-center">
                  <div class="row row-large">
                    <span class="lcu-success-enroll"></span>
                  </div>
                  <div class="row row-large">
                    <span class="lcu-success-msg">
                      ¡Felicitaciones! ¡Te has inscrito con éxito en Legacy Christian University!
                    </span>
                  </div>
                  <div class="row">
                    <button-cta
                      border
                      :classes="['lcu-forward-btn']"
                      :text="'IR AL PANEL DE CONTROL'"
                      @on-click="$router.push({ path: '/tablero-de-control' })" />
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div class="row row-large" v-show="signupError" id="enroll-error">
          <span class="lcu-enroll-errorMsg lcu-center-text">
            {{ signupError }}
          </span>
        </div>
        <!-- Resend code helper -->
        <div class="row row-center row-large">
          <!-- Mini footer -->
          <span class="lcu-enroll-footer">
            ¿Ya estás inscrito?
            <router-link
              class="lcu-login-link"
              to="/iniciar-sesion">
              Inicia sesión aqui.
            </router-link>
            <p>
              <a
                href="#"
                class="lcu-powered-link"
                rel="noopener noreferrer"
                target="_blank">
                Powered by Legacy Christian University
              </a>
            </p>
          </span>
        </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import vueRecaptcha from 'vue3-recaptcha2';
import { Country } from 'country-state-city';
import FormField from 'ç/forms/inputs/Field.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import FormValidator from '@/mixins/Validator.vue';
import Auth from '@/mixins/Auth.vue';
import passwordCriteria from '@/mixins/PasswordCriteria.vue';
import Tooltip from 'ç/tooltip/Tooltip.vue';
import BulletLegend from 'ç/bullet-legend/BulletLegend.vue';
import Footer from 'ç/footer/Footer.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';
import { NOTIFICATION_SUCCESS, NOTIFICATION_ERROR } from '@/globals/constants';

const RE_CAPTCHA_ERROR = 'Hubo un error con el servicio de reCaptcha.';
const TERMS_LABEL = 'Acepto los términos y condiciones de LCU. ';

export default {
  name: 'enroll-page',
  mixins: [Auth, FormValidator, passwordCriteria],
  components: {
    UnauthNav,
    SpinLoader,
    Footer,
    ButtonCta,
    Tooltip,
    vueRecaptcha,
    BulletLegend,
    SecondaryNav,
    'form-field': FormField,
  },
  computed: {
     ...mapGetters(['testMode']),
    countries() {
      return this.allCountries.map(c => c.name);
    },
    getCurrentStep() {
      if (this.enrollStep === 'fee') {
        return 4;
      }
      if (this.enrollStep === 'confirm-account') {
        return 3;
      }
      if (this.enrollStep === 'security') {
        return 2;
      }
      return 1;
    },
    newPassError() {
      return this.validations.newPassword.errors.length > 0 || this.confirmError;
    },
    confirmPassError() {
      return this.validations.confirmPass.errors.length > 0 || this.confirmError;
    },
    showCriteriaError() {
      const input = this.validations.newPassword.value.replace(/\s+/g, '');
      return !this.criteriaPass && input !== '';
    },
  },
  data() {
    return {
      loaders: {
        security: false,
        confirmCode: false,
        confirmAndPay: false,
      },
      confirmPass: '',
      showCompletedEnrollment: false,
      enrollStep: 'profile',
      pais: 'pais',
      género: 'género',
      countryError: false,
      genderError: false,
      validations: {
        firstName: {
          value: '',
          required: true,
          errors: [],
        },
        lastName: {
          value: '',
          required: true,
          errors: [],
        },
        email: {
          value: '',
          required: true,
          errors: [],
        },
        birthday: {
          value: '',
          required: true,
          format: /^(0[1-9]|1[0-2]) \/ (0[1-9]|1\d|2\d|3[01]) \/ (19|20)\d{2}$/,
          errors: [],
        },
        phone: {
          value: '',
          required: true,
          errors: [],
        },
        newPassword: {
          value: '',
          required: true,
          errors: [],
        },
        confirmPass: {
          value: '',
          required: true,
          errors: [],
        },
        code: {
          value: '',
          required: true,
          errors: [],
        },
        cardNum: {
          value: '',
          required: true,
          errors: [],
        },
        expDate: {
          value: '',
          required: true,
          errors: [],
        },
        cvv: {
          value: '',
          required: true,
          errors: [],
        },
        name: {
          value: '',
          required: true,
          errors: [],
        },
      },
      agreeTerms: false,
      savePaymentMethod: true,
      confirmError: false,
      showNewPass: false,
      showConfirmPass: false,
      signupError: false,
      resendLoading: false,
      resendSuccess: false,
      reCaptchaKey: null,
      allCountries: [],
      discountApplied: false,
      discount: '',
      discountError: false,
      discountLoader: false,
      savings: false,
      initialPricing: {
        subtotal: '—',
        total: '—',
        taxes: '—',
        currency: 'usd',
      },
      pricing: {
        subtotal: '—',
        total: '—',
        taxes: '—',
        currency: 'usd',
      },
      TERMS_LABEL,
    };
  },
  created() {
    this.allCountries = Country.getAllCountries();
    this.resetHint();
    this.reCaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
  },
  methods: {
    resetCaptcha() {
      if (this.$refs.vueRecaptcha) {
        this.$refs.vueRecaptcha.reset();
      }
    },
    validateSelects({ error, value }) {
      this[error] = false;
      if (this[value] === value || this[value] === '') {
        this[error] = true;
      }
      return {
        passed: !this[error],
      };
    },
    validateProfileStep() {
      try {
        const validation = this.validate([
          'firstName',
          'lastName',
          'email',
          'birthday',
          'phone',
        ]);
        const countryFailed = !this.validateSelects({ error: 'countryError', value: 'pais' }).passed;
        const genderFailed = !this.validateSelects({ error: 'genderError', value: 'género' }).passed;
        if (!validation.passed || countryFailed || genderFailed) {
          return;
        }
        this.enrollStep = 'security';
      } catch (error) {
        const message = error.message || error;
        setTimeout(() => {
          window.scrollTo(0, document.body.scrollHeight);
        }, 500);
        this.$log.error(message);
      }
    },
    async validateSecurityStep() {
      this.signupError = false;
      try {
        const validation = this.validate([
          'newPassword',
          'confirmPass',
        ]);
        if (!validation.passed) {
          return;
        }
        if (!this.criteriaPass) {
          return;
        }
        if (this.confirmError) {
          return;
        }
        await this.$refs.vueRecaptcha.execute();
      } catch (error) {
        const message = error.message || error;
        this.signupError = message;
        setTimeout(() => {
          window.scrollTo(0, document.body.scrollHeight);
        }, 500);
        this.$log.error(message);
      }
    },
    async onSignup(token) {
      this.resetCaptcha();
      this.signupError = false;
      try {
        this.loaders.security = true;
        const valid = await this.$validSession();
        if (valid) {
          this.$log.info('Session found, logging out.');
          await this.$logout();
          this.$clearAuthStorage();
          this.$store.dispatch('logoutUser');
        }
        const {
          firstName,
          lastName,
          newPassword,
          email,
        } = this.validations;
        const country = this.pais === 'pais' ? 'United States' : this.pais;
        await axios({
          method: 'post',
          url: process.env.VUE_APP_SIGNUP_ENDPOINT,
          data: {
            firstName: firstName.value,
            lastName: lastName.value,
            email: email.value,
            country,
            password: newPassword.value,
            token,
          },
        });
        await this.$cognitoLogin({
          user: email.value,
          pass: newPassword.value,
        });
      } catch (error) {
        if (error && error.code === 'UserNotConfirmedException') {
          this.enrollStep = 'confirm-account';
        } else {
          const message = error?.response?.data?.result || error.message || error;
          this.signupError = message;
          setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
          }, 500);
          this.$log.error(message);
        }
      } finally {
        this.loaders.security = false;
      }
    },
    async validateConfirmCode() {
      this.signupError = false;
      try {
        const validation = this.validate(['code']);
        if (!validation.passed) {
          return;
        }
        this.loaders.confirmCode = true;
        const {
          code,
          newPassword,
          email,
          birthday,
          phone,
        } = this.validations;
        await this.$confirmNewUser({
          code: code.value,
          user: email.value,
          pass: newPassword.value,
        });
        const payload = {
          birthday: birthday.value,
          gender: this.género,
          phone: phone.value,
        };
        await this.$validateSession();
        // Note: this will create the new user data in the db
        await this.$students({ method: 'getUserData', payload });
        const { price } = await this.$students({ method: 'getEnrollmentPricing' });
        this.$log.info('Enrollment price: ', price);
        this.pricing = price;
        this.initialPricing = _.cloneDeep(price);
        this.enrollStep = 'fee';
      } catch (e) {
        const message = e.message || e;
        this.signupError = message;
        this.$log.error(message);
      } finally {
        this.loaders.confirmCode = false;
      }
    },
    clearDiscount() {
      this.discountApplied = false;
      this.discount = '';
      this.pricing = _.cloneDeep(this.initialPricing);
      this.savings = false;
    },
    async onApplyDiscount() {
      if (this.discountLoader) {
        return;
      }
      this.discountError = false;
      if (this.discount === '') {
        this.discountError = this.formValidationMessages.required;
        return;
      }
      this.discountLoader = true;
      this.discountApplied = false;
      try {
        await this.$validateSession();
        const { USD } = await this.$students({
          method: 'couponCheck',
          payload: {
            productMapId: 'enrollmentFee',
            code: this.discount,
          },
        });
        this.pricing.total = USD.newTotal;
        this.pricing.taxes = USD.newTaxes;
        this.savings = USD.savings;
        this.discountApplied = true;
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Código de descuento válido',
          type: 'success',
        });
      } catch (e) {
        const message = e.message || e;
        this.discountError = message;
        this.pricing = _.cloneDeep(this.initialPricing);
        this.$log.error(message);
      } finally {
        this.discountLoader = false;
      }
    },
    validateDiscount() {
      if (this.discount === '') {
        this.discountError = this.formValidationMessages.required;
      } else {
        this.discountError = false;
      }
    },
    async confirmAndPay() {
      this.signupError = false;
      try {
        const validation = this.validate([
          'cardNum',
          'expDate',
          'cvv',
          'name',
        ]);
        if (!validation.passed) {
          return;
        }
        this.loaders.confirmAndPay = true;
        const {
          cardNum,
          expDate,
          cvv,
          name,
        } = this.validations;
        await this.$validateSession();
        const { updates } = await this.$students({
          method: 'payAndEnroll',
          payload: {
            discountCode: this.discount,
            card: {
              number: cardNum.value,
              cvc: cvv.value,
              name: name.value,
              expDate: expDate.value,
              savePaymentMethod: this.savePaymentMethod,
            },
          },
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.user,
          key: 'fees',
          value: updates.fees,
        });
        this.showCompletedEnrollment = true;
      } catch (e) {
        const message = e.message || e;
        this.signupError = message;
        this.$log.error(message);
      } finally {
        this.loaders.confirmAndPay = false;
      }
    },
    recaptchaError() {
      this.signupError = RE_CAPTCHA_ERROR;
    },
    recaptchaFailed(reason) {
      this.signupError = RE_CAPTCHA_ERROR;
      this.$log.error(`reCaptcha failed: ${reason}`);
    },
    async resendCode() {
      try {
        this.resendLoading = true;
        const { email } = this.validations;
        await this.$resendNewUserCode({
          email: email.value,
        });
        this.resendSuccess = true;
        setTimeout(() => {
          this.resendSuccess = false;
        }, 2000);
      } catch (e) {
        const message = e.message || e;
        this.$notify({
          title: NOTIFICATION_ERROR,
          text: message,
          type: 'error',
          duration: -1,
        });
        this.$log.error(message);
      } finally {
        this.resendLoading = false;
      }
    },
    checkConfirm() {
      this.validations.newPassword.value = this.validations.newPassword.value.replace(/\s+/g, '');
      if (this.validations.confirmPass.value.trim() !== '') {
        this.checkPass();
      }
    },
    checkPass() {
      const { confirmPass, newPassword } = this.validations;
      if (newPassword.value === confirmPass.value) {
        this.confirmError = false;
      } else {
        this.confirmError = this.formValidationMessages.passwordMatch;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-enroll-page {
  background-color: $white;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 0 $public-nav-height;

  .lcu-secondary-nav {
    margin: $public-nav-height 0;
  }

  @media only screen and (max-width: $mobile-max) {

    .lcu-secondary-nav {
      margin: 0 0 50px;
    }
  }
}

.lcu-enroll-logo {
  width: 100px;
}

.lcu-enroll-box {
  background-color: $white;
  padding: 0;
  width: 90%;

  @media screen and (min-width: $desktop-min) {
    width: 800px;
  }
}

.lcu-box-large {
    @media screen and (min-width: $desktop-min) {
    width: 1000px;
  }
}

.lcu-enroll-header {
  color: $legacy-primary;
  font-size: 24px;
}

.lcu-enroll-inputText {
  background-color: transparent;
  border: 0;
  border-bottom: 2px solid $legacy-primary;
  color: $legacy-primary;
  font-size: 21px;
  padding: 5px;
  width: 100%;

  &:focus-visible {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }

  &:focus {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }

  &:focus-within {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }
}

.lcu-form-riser {
  color: $legacy-primary;
  display: inline-block;
  font-size: 21px;
  margin-left: 5px;
  pointer-events: none;
  position: absolute;
  transform: translateY(6px);
  transition-duration: .1s;
}

.lcu-form-risen {
  font-size: 13px;
  transform: translateY(-15px);
}

.lcu-enroll-selectWrap {
  font-size: 13px;
  position: relative;
}

.lcu-active-selectRequired {
    &:after {
      color: $danger;
      content: '\e819';
      display: inline-block;
      font-family: 'lcu';
      font-size: 9px;
      position: absolute;
      top: 18px;
      left: 90px;
    }
}

.lcu-enroll-select {
  appearance: none;
  background-color: $white;
  border: 2px solid $legacy-primary;
  color: $legacy-primary;
  font-size: 21px;
  padding: 8px 10px;
  width: 100%;

  &:focus {
    border-color: $legacy-primary;
    outline: none;
  }

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    border-color: $legacy-primary;
    outline: none;
  }
}

.lcu-enroll-selectIcon {
  bottom: 10px;
  color: $legacy-primary;
  font-size: 14px;
  right: 10px;
  pointer-events: none;
  position: absolute;

  &:before {
    display: inline-block;
    content: '\e817';
    font-family: 'lcu';
  }
}

.lcu-passHint-group {
  background-color: $gray-lightest;
  color: $gray-dark;
  border: 1px solid $page-border;
}

.lcu-icon-eyeSlash {
  background-color: transparent;
  border: 0;
  color: #6f6f6f;
  display: inline-block;
  font-size: 21px;
  position: absolute;
  right: 3px;
  text-align: center;
  top: 3px;

  &:hover {
    cursor: pointer;
  }

  &:before {
    content: '\e806';
  }
}

.lcu-icon-eye {

  &:before {
    content: '\e81c';
    font-family: 'lcu';
  }
}

.lcu-enroll-required {

  &:before {
    color: $danger;
    content: '\e819';
    display: inline-block;
    font-family: 'lcu';
    font-size: 9px;
    margin-left: 5px;
    position: relative;
    top: -2px;
  }
}

.lcu-form-risen {

  .lcu-enroll-required {

    &:before {
      font-size: 7px;
    }
  }
}

.lcu-enroll-errorMsg {
  color: $danger;
  display: inline-block;
  font-size: 16px;
}

.lcu-enroll-btn {
  background-color: $legacy-primary;
  color: $black;
  padding: 12px 0;

  &:hover {
    background-color: darken($legacy-primary, 5);
  }
}

.lcu-enroll-inputError {
  background-color: #ffe6e6;
  border-color: $danger;

  &:focus-visible {
    border-color: $danger;
  }

  &:focus {
    border-color: $danger;
  }

  &:focus-within {
    border-color: $danger;
  }
}

.lcu-enroll-footer {
  color: rgba($black, .6);
  padding-top: 50px;
  text-align: center;
}

.lcu-powered-link {
  color: $legacy-primary;
  font-size: 13px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.lcu-login-link {
  color: $legacy-primary;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.lcu-mobile-bump {

  @media only screen and (max-width: $mobile-max) {
    margin-bottom: 35px;
  }
}

.lcu-login-smallP {
  color: rgba($black, .6);
  text-align: center;
}

.lcu-enroll-formError {
  background-color: #ffe8e8;
  border: 2px solid $danger;
  border-radius: 3px;
  padding: 20px;
}

.lcu-back-icon {
    &:before {
    display: inline-block;
    content: '\e81f';
    font-family: "lcu";
    margin-right: 5px;
    font-weight: bold;
  }
}

.lcu-summary-box {
  padding: 25px 20px;
  border-radius: 3px;
  background-color: $off-white;
}

.lcu-summary-item {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 25px;
}

.lcu-summary-itemImage {
  width: 140px;
  border: 1px solid $gray;
}

.lcu-summary-totals {
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: 30px;
  grid-row-gap: 10px;

  span {
    justify-self: end;
  }
}

.lcu-summary-total {
  font-family: raleway-extra-bold;
  font-size: 18px;
}

.lcu-success-enroll {
  display: inline-block;
  color: $success;
  font-size: 80px;

  &:after {
    font-family: 'lcu';
    content: '\e801';
  }
}

.lcu-success-msg {
  font-size: 24px;
  text-align: center;
  font-family: 'raleway-bold';
}

.lcu-forward-btn {
    &:after {
      display: inline-block;
      font-family: 'lcu';
      content: '\e80a';
      margin-left: 10px;
  }
}

.lcu-form-checkbox {
  background-color: rgba($black, .05);

  &:checked {
    background-color: $legacy-primary;
  }
}

.full-width-btn {
  width: 100%;
}

.lcu-fee-price {
  text-transform: uppercase;
}

.lcu-discount-input {
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-gap: 10px;
  justify-content: end;
  align-items: center;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-register-inputError {
  background-color: #ffe6e6;
  border-color: $danger;

  &:focus-visible {
    border-color: $danger;
  }

  &:focus {
    border-color: $danger;
  }

  &:focus-within {
    border-color: $danger;
  }
}

.lcu-discount-errorMsg {
  color: $danger;
  display: inline-block;
  font-size: 16px;
}

.lcu-summary-savings {
  color: $success;
  font-weight: bold;
}

.lcu-input-discount {
  color: $legacy-primary;
}

.lcu-disabled-input {
  background-color: $gray-lightest;
  color: #818181;

  &:hover {
    cursor: not-allowed;
  }

  &:focus {
    border-color: transparent;
  }

  &:focus-within {
    border-color: transparent;
  }
}

.coming-soon {
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
}
</style>
